/**
 * Fit-text directive: dynamically adjust font-size so text fills container width.
 * Usage: <h1 v-fit-text>Text here</h1>
 * Only active above 769px viewport (desktop).
 */
export const FitText = {
    mounted(el) {
        el._fitTextHandler = () => fitText(el);
        fitText(el);
        window.addEventListener('resize', el._fitTextHandler);
    },
    unmounted(el) {
        if (el._fitTextHandler) {
            window.removeEventListener('resize', el._fitTextHandler);
        }
    },
};

/**
 * Standalone initializer: finds all elements with [data-fit-text]
 * and applies fitText without requiring a Vue app wrapper.
 */
export function initFitText() {
    const elements = document.querySelectorAll('[data-fit-text]');
    elements.forEach(el => {
        // Remove previous listener if any
        if (el._fitTextHandler) {
            window.removeEventListener('resize', el._fitTextHandler);
        }
        el._fitTextHandler = () => fitText(el);
        fitText(el);
        window.addEventListener('resize', el._fitTextHandler);
    });
}

function fitText(el) {
    // Only apply on desktop
    if (window.innerWidth <= 768) {
        el.style.fontSize = '';
        return;
    }

    const containerWidth = el.parentElement
        ? el.parentElement.clientWidth
        : el.clientWidth;

    // Reset to measure natural width
    el.style.fontSize = '100px';

    // Create a temporary span to measure text at 100px
    const span = document.createElement('span');
    const computed = window.getComputedStyle(el);
    span.style.cssText = `
        font: ${computed.fontWeight} 100px ${computed.fontFamily};
        letter-spacing: ${computed.letterSpacing};
        position: absolute;
        visibility: hidden;
        white-space: nowrap;
    `;
    document.body.appendChild(span);

    // Measure total text width at 100px
    span.textContent = el.textContent.trim();
    const textWidthAt100 = span.offsetWidth;

    // Force 2 lines for hero title
    const targetLines = parseInt(el.getAttribute('data-fit-text')) || 2;

    // Calculate font size so text fills targetLines lines
    // Measure single-line text at 100px, then scale to fit targetLines * containerWidth
    const fontSize = Math.floor((containerWidth * targetLines / textWidthAt100) * 100 * 0.95);

    // Clamp between 48px and 140px
    const clampedSize = Math.max(48, Math.min(140, fontSize));

    el.style.fontSize = clampedSize + 'px';

    document.body.removeChild(span);
}
